export enum FacilitiesTrainersTabs {
  Trainers = "TRAINERS",
  Facilities = "FACILITIES",
}

export enum AvatarType {
  WithPhoto = "WITH_PHOTO",
  WithoutPhoto = "WITHOUT_PHOTO",
}

export enum PlaceType {
  UserGym = "USER_GYM",
  TrainerGym = "TRAINER_GYM",
  UserHome = "USER_HOME",
}

export enum ProfileSettings {
  UserSettings = "USER_SETTINGS",
}
